import React from 'react';
import { usePWA } from '@/context/pwa-context';
import { Download, X, Smartphone, Monitor } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { motion, AnimatePresence } from 'framer-motion';

const PWAInstallPopup: React.FC = () => {
  const { showInstallPopup, installApp, dismissPopup, isInstallable } = usePWA();

  if (!isInstallable) return null;

  return (
    <AnimatePresence>
      {showInstallPopup && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          className="fixed bottom-6 left-6 right-6 md:left-auto md:right-8 md:w-[400px] z-[100]"
        >
          <div className="bg-[#0c0c0e] border border-white/10 rounded-[2.5rem] p-8 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.5)] backdrop-blur-xl relative overflow-hidden">
            {/* Background Accent */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-3xl -mr-16 -mt-16" />
            
            <button 
              onClick={dismissPopup}
              className="absolute top-4 right-4 p-2 text-zinc-500 hover:text-white transition-colors"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="flex items-start gap-5 relative z-10">
              <div className="w-14 h-14 bg-primary/10 rounded-2xl flex items-center justify-center border border-primary/20 shrink-0">
                <Download className="w-7 h-7 text-primary" />
              </div>
              <div className="space-y-2">
                <h3 className="text-xl font-bold text-white uppercase tracking-tight leading-tight">Install Fun Circle Games</h3>
                <p className="text-zinc-400 text-sm font-medium leading-relaxed">
                  Add to your home screen for fast, full-screen access to our physics sandbox.
                </p>
                
                <div className="flex items-center gap-4 pt-2">
                  <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-zinc-500">
                    <Smartphone className="w-3 h-3" /> Mobile
                  </div>
                  <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-zinc-500">
                    <Monitor className="w-3 h-3" /> Desktop
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 flex gap-3">
              <Button 
                onClick={installApp}
                className="flex-grow h-12 bg-primary text-primary-foreground font-black uppercase tracking-widest rounded-xl hover:bg-cyan-400 transition-all shadow-lg shadow-primary/10"
              >
                Install Now
              </Button>
              <Button 
                variant="outline"
                onClick={dismissPopup}
                className="h-12 border-white/5 bg-white/5 text-white font-black uppercase tracking-widest rounded-xl hover:bg-white/10 transition-all"
              >
                Later
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PWAInstallPopup;
